import type { GetOrganisationVisibilityScoreQuery } from '@graphql/__generated__/graphql';
import type {
  VisibilityCountry,
  VisibilityScore,
} from '@modules/_shared/visibility-scoring';
import type { useLocale } from '@shared/hooks/locale';

import type { VisibilityScoreResult } from './visibilityScorePresenter';
import { presentVisibilityScore } from './visibilityScorePresenter';

type VisibilityActionOutput = NonNullable<
  GetOrganisationVisibilityScoreQuery['organisation_visibility_score']
>;

type VisibilityActionWindow = VisibilityActionOutput['current'];

export const visibilityWindowToScore = (
  window: VisibilityActionWindow,
): VisibilityScore => ({
  score: window.score,
  rawScore: window.raw_score,
  profilePoints: window.profile_points,
  valuationPoints: window.valuation_points,
  profileViewsTotal: window.profile_views_total,
  valuationViewsTotal: window.valuation_views_total,
  phoneClicksTotal: window.phone_clicks_total,
  profileViewsTarget: window.profile_views_target,
  effectiveImpressions: window.effective_impressions,
  targetImpressions: window.target_impressions,
  country: null,
  positionBreakdown: window.position_breakdown.map(row => ({
    position: row.position,
    count: row.count,
    weight: row.weight,
    weighted: row.weighted,
  })),
  sellerContactTargetPerMonth: window.seller_contact_target_per_month ?? null,
  sizeMultiplier: window.size_multiplier,
  transactionsCount24mo: window.transactions_count_24mo,
});

export const presentVisibilityScoreFromAction = ({
  action,
  t,
}: {
  action: VisibilityActionOutput;
  t: ReturnType<typeof useLocale>['t'];
}): {
  current: VisibilityScoreResult;
  previous: VisibilityScoreResult;
  delta: number;
} => ({
  current: presentVisibilityScore({
    score: {
      ...visibilityWindowToScore(action.current),
      country: action.country as VisibilityCountry | null,
    },
    t,
  }),
  previous: presentVisibilityScore({
    score: {
      ...visibilityWindowToScore(action.previous),
      country: action.country as VisibilityCountry | null,
    },
    t,
  }),
  delta: action.delta,
});
